(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadDeleteController',SSModalidadDeleteController);

    SSModalidadDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSModalidad'];

    function SSModalidadDeleteController($uibModalInstance, entity, SSModalidad) {
        var vm = this;

        vm.sSModalidad = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSModalidad.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
